import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";

import { NzSafeAny } from "ng-zorro-antd/core/types";
import { NzTableSelectionComponent } from "ng-zorro-antd/table";

@Component({
  selector: "ui-table-selection",
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: "selection.component.html",
})
export class UiTableSelectionComponent extends NzTableSelectionComponent {
  @Input("listOfSelections") public listOfSelections: Array<{ text: string; onSelect(...args: NzSafeAny[]): NzSafeAny }> = [];
  @Input("checked") public checked = false;
  @Input("disabled") public disabled = false;
  @Input("indeterminate") public indeterminate = false;
  @Input("showCheckbox") public showCheckbox = false;
  @Input("showRowSelection") public showRowSelection = false;
  @Output("checkedChange") public readonly checkedChange = new EventEmitter<boolean>();
}
